import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import {
  SeoCmsCategoryDetailRBAC,
  SeoCmsCategoryListRBAC,
  SeoCmsCatalogueDetailRBAC,
  SeoCmsCatalogueListRBAC,
  SeoCmsDlpDetailRBAC,
  SeoCmsDlpListRBAC,
  SeoCmsHomeRBAC,
} from './rbac'

const HomePage = lazy(() => import('../pages/Home/Home'))
const CategoryListPage = lazy(() => import('../pages/CategoryList/CategoryList'))
const CategoryDetailPage = lazy(() => import('../pages/CategoryDetail/CategoryDetail'))
const CataloguePage = lazy(() => import('../pages/CatalogueList/CatalogueList'))
const CatalogueDetailPage = lazy(() => import('../pages/CatalogueDetail/CatalogueDetail'))
const DlpPage = lazy(() => import('../pages/DlpList/DlpList'))
const DlpDetailPage = lazy(() => import('../pages/DlpDetail/DlpDetail'))

export type SeoCmsNamedRoutesType =
  | 'SeoCmsHomeRouter'
  | 'SeoCmsCategoryListRouter'
  | 'SeoCmsCategoryDetailRouter'
  | 'SeoCmsCatalogueRouter'
  | 'SeoCmsCatalogueDetailRouter'
  | 'SeoCmsDlpRouter'
  | 'SeoCmsDlpDetailRouter'

export type SeoCmsPathListsType =
  | '/dashboard/seo-cms/home'
  | '/dashboard/seo-cms/category'
  | '/dashboard/seo-cms/category/:targetValueId/:contentType'
  | '/dashboard/seo-cms/catalogue'
  | '/dashboard/seo-cms/catalogue/:targetValueId/:contentType'
  | '/dashboard/seo-cms/dlp'
  | '/dashboard/seo-cms/dlp/:targetValueId/:contentType'

type SeoCmsRouterType = RouterFeatureInterface<SeoCmsNamedRoutesType, SeoCmsPathListsType>

export const SeoCmsHomeRouter: SeoCmsRouterType = {
  name: 'SeoCmsHomeRouter',
  Component: HomePage,
  path: '/dashboard/seo-cms/home',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsHomeRBAC.pageID,
}

export const SeoCmsCategoryListRouter: SeoCmsRouterType = {
  name: 'SeoCmsCategoryListRouter',
  Component: CategoryListPage,
  path: '/dashboard/seo-cms/category',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsCategoryListRBAC.pageID,
}

export const SeoCmsCategoryDetailRouter: SeoCmsRouterType = {
  name: 'SeoCmsCategoryDetailRouter',
  Component: CategoryDetailPage,
  path: '/dashboard/seo-cms/category/:targetValueId/:contentType',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsCategoryDetailRBAC.pageID,
}

export const SeoCmsCatalogueRouter: SeoCmsRouterType = {
  name: 'SeoCmsCatalogueRouter',
  Component: CataloguePage,
  path: '/dashboard/seo-cms/catalogue',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsCatalogueListRBAC.pageID,
}

export const SeoCmsCatalogueDetailRouter: SeoCmsRouterType = {
  name: 'SeoCmsCatalogueDetailRouter',
  Component: CatalogueDetailPage,
  path: '/dashboard/seo-cms/catalogue/:targetValueId/:contentType',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsCatalogueDetailRBAC.pageID,
}

export const SeoCmsDlpRouter: SeoCmsRouterType = {
  name: 'SeoCmsDlpRouter',
  Component: DlpPage,
  path: '/dashboard/seo-cms/dlp',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsDlpListRBAC.pageID,
}

export const SeoCmsDlpDetailRouter: SeoCmsRouterType = {
  name: 'SeoCmsDlpDetailRouter',
  Component: DlpDetailPage,
  path: '/dashboard/seo-cms/dlp/:targetValueId/:contentType',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SeoCmsDlpDetailRBAC.pageID,
}

const SeoCmsRouter = [
  SeoCmsHomeRouter,
  SeoCmsCategoryListRouter,
  SeoCmsCategoryDetailRouter,
  SeoCmsCatalogueRouter,
  SeoCmsCatalogueDetailRouter,
  SeoCmsDlpRouter,
  SeoCmsDlpDetailRouter,
]

export const SeoCmsRouterDetail = generateRouterDetail(SeoCmsRouter)
export default SeoCmsRouter
